import { Component } from 'react';

export default class AppErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, details) {
    // Keep technical diagnostics in the console while presenting a useful,
    // branded recovery state instead of an empty page to customers.
    console.error('[VizMarkets] Application render failed', error, details);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="fatal-error" role="alert" aria-labelledby="fatal-error-title">
          <div className="fatal-error-mark" aria-hidden="true">VM</div>
          <p>VIZMARKETS</p>
          <h1 id="fatal-error-title">We couldn’t load your market workspace.</h1>
          <span>
            Refresh the page to try again. If the problem continues, please return in a few minutes.
          </span>
          <button type="button" onClick={() => window.location.reload()}>
            Reload VizMarkets
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
